var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.category)?_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('CategoryTitle',{attrs:{"category":_vm.category}})],1),(_vm.cuFormContent && _vm.config)?_c('v-col',{attrs:{"cols":"12"}},[_c('FormDetail',{attrs:{"cuFormContent":_vm.cuFormContent,"config":_vm.config}})],1):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }